import {
  ArrayField,
  Button,
  Datagrid,
  FunctionField,
  ReferenceManyField,
  SimpleShowLayout,
  TextField,
} from 'react-admin';
import Typography from '@mui/material/Typography';

import { usePetPlanUtilization } from '@pumpkincare/users';

import DateFieldIgnoringZone from '../../../../components/DateFieldIgnoringZone';
import RoutePaths from '../../../../routes';
import { formatCurrency } from '../../../../shared/utils';
import { AuditLogsLink } from '../../../audit-logs';
import FieldStatusChip from '../field-status-chip';
import petShowStyle from '../pet-show-style';

function PetPlansDatagrid(props) {
  const classes = petShowStyle();

  const { onPetCancelClick, ...rest } = props;

  const { record } = rest;

  const { data: petPlanUtilizationData, isLoading: isPEPUtilizationLoading } =
    usePetPlanUtilization(record?.latest_pet_plan?.id);

  const PetPlanTitle = () => {
    return (
      <div className={classes.spacing}>
        <Typography className={classes.title}>Preventive Essentials</Typography>
      </div>
    );
  };

  return (
    <>
      <PetPlanTitle />

      <Typography
        variant='body1'
        style={{ fontWeight: '700', marginBottom: '16px' }}
      >
        Plan Details
      </Typography>

      <SimpleShowLayout className={classes.root} {...rest}>
        <ReferenceManyField
          label={''}
          reference={RoutePaths.petPlans}
          target='pet_id'
          sort={{ field: 'created_at', order: 'DESC' }}
        >
          <Datagrid
            sx={{
              '& .RaDatagrid-headerCell': {
                color: '#2D2D2D',
                backgroundColor: '#D9D9D9',
                textTransform: 'uppercase',
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: '10px',
                lineHeight: '16px',
                letterSpacing: '1.5px',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              },
            }}
            bulkActionButtons={false}
            style={{ maxWidth: '830px' }}
            rowClick={false}
          >
            <FieldStatusChip label='Status' />

            <TextField label='Cost' source='plan.cost' />

            <TextField label='Description' source='plan.description' />

            <FunctionField
              label='Effective Date'
              render={(record = {}) => {
                return (
                  <DateFieldIgnoringZone
                    source='plan_effective_date'
                    record={record}
                  />
                );
              }}
            />

            <FunctionField
              label='End Date'
              render={(record = {}) => {
                return (
                  <DateFieldIgnoringZone source='plan_end_date' record={record} />
                );
              }}
            />

            <TextField label='Is annual?' source='is_annualized_pet_plan' />

            <FunctionField
              label=''
              render={(record = {}) => {
                return <AuditLogsLink filter={{ pet_plan_id: record.id }} />;
              }}
            />

            <FunctionField
              label=''
              render={(record = {}) => {
                if (record.status === 'renew_pending') {
                  return (
                    <Button
                      style={{
                        color: '#D4424E',
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                      }}
                      variant='outlined'
                      onClick={() => onPetCancelClick(record)}
                      label='DECLINE'
                    />
                  );
                } else {
                  return null;
                }
              }}
            />
          </Datagrid>
        </ReferenceManyField>
        <Typography
          variant='body1'
          style={{ fontWeight: '700', marginBottom: '16px', marginTop: '32px' }}
        >
          Utilization
        </Typography>
        <ArrayField
          label=''
          source='pep_utilization'
          record={{
            pep_utilization: isPEPUtilizationLoading
              ? []
              : petPlanUtilizationData.entitlements,
          }}
        >
          <Datagrid
            bulkActionButtons={false}
            sx={{
              '& .RaDatagrid-headerCell': {
                color: '#2D2D2D',
                backgroundColor: '#D9D9D9',
                textTransform: 'uppercase',
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: '10px',
                lineHeight: '16px',
                letterSpacing: '1.5px',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              },

              '& .RaDatagrid-rowCell': { textAlign: 'right' },
              '& .RaDatagrid-tableWrapper': { width: '730px' },
            }}
          >
            <FunctionField
              label='Item name'
              render={(record = {}) => (
                <div style={{ textAlign: 'left' }}>{record.name}</div>
              )}
              headerClassName={classes.colHeader}
            />
            <FunctionField
              label='Item description'
              render={(record = {}) => (
                <div style={{ textAlign: 'left' }}>{record.details}</div>
              )}
              headerClassName={classes.colHeader}
            />
            <FunctionField
              label={'Total Qty'}
              render={(record = {}) => record.total}
              headerClassName={classes.colHeader}
            />
            <FunctionField
              label={'Used Qty'}
              render={(record = {}) => record.utilized}
              headerClassName={classes.colHeader}
            />
            <FunctionField
              label={'Pending'}
              render={(record = {}) => record.pending}
              headerClassName={classes.colHeader}
            />
          </Datagrid>
        </ArrayField>
        <Typography variant='body2' style={{ fontWeight: '700', marginTop: '16px' }}>
          Annual Cap{' '}
        </Typography>

        <span>
          {formatCurrency(petPlanUtilizationData?.annual_cap.utilized, {
            areCents: true,
            hideZero: true,
          })}{' '}
          of{' '}
          {formatCurrency(petPlanUtilizationData?.annual_cap.entitlement, {
            areCents: true,
            hideZero: false,
          })}
        </span>
      </SimpleShowLayout>
    </>
  );
}
export default PetPlansDatagrid;
